import { TableStyles } from "react-data-table-component";
import { PAGE_ROUTES } from "./page-routes";
import { ExternalToast } from "sonner";

export const DEFAULT_APP_VAR: AppVars = {
  isUserLoggedIn: false,
  accessToken: "",
  user_id: "",
  accessJWT: "",
  isCollapsed: false,
  isFirstTime: true,
};

export const DEFAULT_BOOKING_VAR: BookingVars = {
  selectedClinicId: "",
  selectedTherapyId: "",
  selectedPractitionerId: "",
};

export const DEFAULT_SESSION_BOOKING_VAR: SessionBookingVars = {
  clinicId: "",
  therapyId: "",
  patientId: "",
  date: "",
  time: "",
};

export const DEFAULT_CHECKOUT_VAR: CheckoutStateVars = {
  checkoutSessionId: "",
  transactionId: "",
  url: "",
  status: "pending",
  practitioner: null,
};

export const EMPTY = "";
export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";
export const ALL = "all";

export const USER_ROLES = {
  SUPER: "super",
  PATIENT: "patient",
  PRACTITIONER: "practitioner",
  ADMIN: "admin",
  RECEPTIONIST: "receptionist",
};

export const CLINIC_USER_ROLES = {
  ADMIN: "admin",
  RECEPTIONIST: "receptionist",
};

export const DEFAULT_LOCAL_STORAGE_KEY_FOR_APP_STATE = "SWC_APP_STATE";
export const DEFAULT_LOCAL_STORAGE_KEY_FOR_USER_STATE = "SWC_USER_STATE";

export const DEFAULT_LOCAL_STORAGE_KEY_FOR_BOOKING_STATE = "SWC_BOOKING_STATE";
export const DEFAULT_LOCAL_STORAGE_KEY_FOR_SESSION_BOOKING_STATE = "SWC_SESSION_BOOKING_STATE";
export const DEFAULT_LOCAL_STORAGE_KEY_FOR_PRACTITIONER_SUBSCRIPTION_STATE =
  "SWC_PRACTITIONER_SUBSCRIPTION_STATE";

export const APP_CONVERSION_DATE_FORMAT = "dd/MM/yyyy";
export const APP_SHORT_DATE_FORMAT = "dd MMM yyyy";
export const APP_AWS_DATE_FORMAT = "yyyy-MM-dd";
export const APP_LONG_DATE_FORMAT = "DDDD";
export const APP_ORDER_NUMBER_FORMAT = "yyyy/dd/#";

export const GBP_SYMBOL = "£";
export const PARKING_FEE = "50";
export const ENCODER_SECRET_KEY = "2ff493499f93c38bbd00f4a64941dc4e";

export const UNAVAILABLE_DAYS = {
  HOLIDAY: "holiday",
  UNAVAILABLE: "unavailable",
  PRACTITIONER_BOOKINGS: "practitionerBookings",
};

export const SUBSCRIPTION_DURATIONS = [3, 6, 9, 12];
export const MINIMUM_SUBSCRIPTION_PERIOD = 3; // 3 months

export const DEFAULT_WORKING_HOURS: WorkingHour[] = [
  { day: "Monday", fromTime: "08:00", toTime: "20:00" },
  { day: "Tuesday", fromTime: "08:00", toTime: "20:00" },
  { day: "Wednesday", fromTime: "08:00", toTime: "20:00" },
  { day: "Thursday", fromTime: "08:00", toTime: "20:00" },
  { day: "Friday", fromTime: "08:00", toTime: "20:00" },
  { day: "Saturday", fromTime: "08:00", toTime: "20:00" },
  { day: "Sunday", fromTime: "08:00", toTime: "20:00" },
];

export const DATA_TABLE_DEFAULT_STYLE: TableStyles = {
  table: {
    style: {
      width: "100%",
      minWidth: "600px",
    },
  },
  rows: {
    style: {
      minHeight: "40px",
      border: "1px solid #ccc",
      transition: "all 0.3s ease",
      "@media screen and (max-width: 768px)": {
        minHeight: "35px",
      },
      "@media screen and (max-width: 576px)": {
        minHeight: "30px",
      },
    },
    highlightOnHoverStyle: {
      backgroundColor: "#f5f5f5",
      fontWeight: "bold",
      color: "#000",
      cursor: "pointer",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#FCFCFD",
      color: "#000",
      fontSize: "16px",
      fontWeight: "bold",
      border: "1px solid #ccc",
      "@media screen and (max-width: 768px)": {
        fontSize: "14px",
      },
      "@media screen and (max-width: 576px)": {
        fontSize: "12px",
      },
    },
  },
  cells: {
    style: {
      fontSize: "16px",
      color: "#000",
      padding: "10px",
      "@media screen and (max-width: 768px)": {
        fontSize: "14px",
        padding: "8px",
      },
      "@media screen and (max-width: 576px)": {
        fontSize: "12px",
        padding: "6px",
      },
    },
  },
};


export const CALENDER_COLORS = {
  HOLIDAY: "#a99870",
  UNAVAILABLE: "darkgray",
  TODAY: "#eaf6ff",
  WEEKEND: "#f0f0f0",
  DEFAULT: "#ffffff",
  SELECTED: "#f2f0ea",
};

export const BUSINESS_CATEGORIES = {
  INDIVIDUAL: "Individual",
  ORGANISATION: "Organisation",
};

export const DEFAULT_SELECTED_WEEKDAYS = [];
export const WeekdaysMap: Record<number, string> = {
  0: "Sunday",
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
};

export const SUBSCRIPTION_SUCCESS_URL = `${window.location.origin}${PAGE_ROUTES.PRACTITIONER.Dashboard}`;
export const SUBSCRIPTION_CANCEL_URL = `${window.location.origin}${PAGE_ROUTES.AUTHENTICATION.Login}`;

export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const CUSTOM_REVENUE_TOOLTIP = ({
  series,
  seriesIndex,
  dataPointIndex,
}) => {
  const value = series[seriesIndex][dataPointIndex];
  return `<div style="padding:6px;font-size:13px;">
              <span style="font-weight:bold;">Revenue:</span> ${GBP_SYMBOL}${value}
            </div>`;
};

export const CUSTOM_BOOKINGS_TOOLTIP = ({ series, dataPointIndex }) => {
  const bookings = series[0][dataPointIndex] || 0;
  const subscriptions = series[1][dataPointIndex] || 0;

  return `
    <div style="padding:6px;font-size:13px;">
      <div><strong>Total Bookings:</strong> ${bookings}</div>
      <div><strong>Total Subscriptions:</strong> ${subscriptions}</div>
    </div>
  `;
};

export const CHART_SHADOW: ApexDropShadow = {
  enabled: true,
  blur: 3,
  color: "#999",
  opacity: 0.35,
};

export const ICON_SIZE = 32;

export const ALL_CLINIC_OPTION = {
  id: "all",
  name: "All Clinics",
  address: "",
  postCode: "",
  contactDetails: "",
  noOfAvailableRooms: 0,
  availableHours: DEFAULT_WORKING_HOURS,
  websiteURL: "",
  metadata: {},
  roomNoSequence: "Room-#",
} as Clinic;

export const EMPTY_FILTER_SELECTIONS: FilterSelections = {
  selectedClinicId: "",
  selectedTherapyId: "",
  selectedPractitionerId: "",
};

export const IDLE_TOAST_CONFIG: ExternalToast = {
  duration: 5000,
  position: "top-center",
  richColors: true,
};

export const NETWORK_ERROR_TOAST_CONFIG: ExternalToast = {
  duration: Infinity,
  position: "top-center",
  dismissible: false,
  richColors: true,
  id: "network-error",
};

export const NETWORK_BACK_TOAST_CONFIG: ExternalToast = {
  duration: 5000,
  position: "top-center",
  dismissible: true,
  richColors: true,
  id: "network-back",
};

export const IDLE_TIMER_CONFIG = {
  timeout: Number(process.env.REACT_APP_INACTIVITY_TIMEOUT) ?? 120_000,
  warningTime:
    Number(process.env.REACT_APP_INACTIVITY_TIMEOUT_WARNING) ?? 60_000,
};

export const DEFAULT_USER_PASSWORD =
  process.env.REACT_APP_DEFAULT_USER_PASSWORD;

export const APP_MAINTENANCE_MODE =
  process.env.REACT_APP_MAINTENANCE_MODE === "true";

export const CHART_COLORS_1 = [
  "#4F46E5", // Indigo
  "#22C55E", // Green
  "#EF4444", // Red
  "#F59E0B", // Amber
  "#10B981", // Emerald
  "#3B82F6", // Blue
  "#EC4899", // Pink
  "#6366F1", // Violet
  "#0EA5E9", // Sky
  "#8B5CF6", // Purple
];

export const CHART_COLORS_2 = [
  "#FB923C", // Orange
  "#14B8A6", // Teal
  "#A855F7", // Fuchsia
  "#E11D48", // Rose
  "#84CC16", // Lime
  "#06B6D4", // Cyan
  "#F472B6", // Pink Light
  "#FACC15", // Yellow
  "#9CA3AF", // Cool Gray
  "#F43F5E", // Pink Deep
];

export const COLOR_BY_DAY: Record<number, string> = {
  0: "#FFEBEE", // Sunday
  1: "#E3F2FD", // Monday
  2: "#E8F5E9", // Tuesday
  3: "#FFF3E0", // Wednesday
  4: "#F3E5F5", // Thursday
  5: "#FFFDE7", // Friday
  6: "#ECEFF1", // Saturday
};
